export const FONTHIDE = "FONTHIDE";
export const FONTSE = "FONTSE";
export const NEWNOTE = 'NEWNOTE';
export const OLDNOTE = "OLDNOTE";
export const FONT = "FONT";
export const MAINFONT = "MAINFONT";
export const FONTDISPLAY = "FONTDISPLAY";
export const COLORHIDE = "COLORHIDE";
export const COLORSHOW = "COLORSHOW";
export const OUTER = "OUTER";
export const PINSHORT = "PINSHORT";
export const GRID = "GRID";
export const UPDATENOTE = "UPDATENOTE";
export const DELETENOTE = "DELETENOTE";
export const CLOSED = "CLOSED";
export const SHADES = "SHADES";
export const ARCHIVEGRID = "ARCHIVEGRID";
export const ARCHIVESHADES = "ARCHIVESHADES";
export const DELETEDGRID = "DELETEDGRID";
export const DELETEDSHADES = "DELETEDSHADES";
export const DARKMODE = "DARKMODE";